
import Injection = EECore.Injection;
import Model from "../models/documentCentre/documentCentreModel";
import { WidgetResources } from "../../resources/widget";

@Injection.injectableClass("DocumentCentre")
export default class DocumentCentre implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("DocumentCentre", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("DocumentCentre", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("DocumentCentre", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  constructor(templateFactory: EECore.UI.TemplateFactory, resources: WidgetResources, htmlHelper: EECore.HtmlHelper) {
    this.templateFactory = templateFactory;
    this.resources = resources;
    this.htmlHelper = htmlHelper;
  }

  load(container: Element): Element {
    const title = container.getAttribute("ee-title");
    const component = this.renderTemplate(title);
    this.bindUIEvents(component);

    return component;
  }

  private renderTemplate(title?: string): Element {
    const model: Model = {
      title: title || this.resources.documentCentre.components.documentCentreTitle,
      searchTabTitle: this.resources.documentCentre.tabs.searchLabel,
      favouriteTabTitle: this.resources.documentCentre.tabs.favouriteLabel,
      favouriteUnavailableMessage: this.resources.documentCentre.favourites.unavailableMessage
    };
    return this.templateFactory.getTemplate("DocumentCentre", model);
  }

  private bindUIEvents(component: Element) {
    const tabs = component.querySelectorAll(".documentationcenter_menuItem");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener("click", (event: MouseEvent) => { this.selectTab(event.currentTarget as Element, component); });
      tabs[i].addEventListener("mouseenter", (event: MouseEvent) => { this.enterTab(event.currentTarget as Element); });
      tabs[i].addEventListener("mouseleave", (event: MouseEvent) => { this.exitTab(event.currentTarget as Element); });
    }
  }

  private selectTab(tab: Element, component: Element) {
    if (!this.htmlHelper.hasCssClass(tab, "selection_fix")) {
      const currentTab = component.querySelector(".selection_fix");
      const currentTabContent = component.querySelector(".documentationcenter_content [data-tab].visible");
      const tabName = tab.getAttribute("data-tab");
      const tabContent = component.querySelector(`.documentationcenter_content [data-tab=${tabName}]`);

      this.htmlHelper.removeCssClass(currentTab, "documentationcenter_menuItem_selected");
      this.htmlHelper.removeCssClass(currentTab, "selected");
      this.htmlHelper.removeCssClass(currentTab, "selection_fix");
      this.htmlHelper.removeCssClass(currentTabContent, "visible");
      this.htmlHelper.addCssClass(currentTab, "documentationcenter_menuItem_unselected");
      this.htmlHelper.addCssClass(currentTabContent, "hidden");

      this.htmlHelper.removeCssClass(tab, "documentationcenter_menuItem_unselected");
      this.htmlHelper.removeCssClass(tabContent, "hidden");
      this.htmlHelper.addCssClass(tab, "documentationcenter_menuItem_selected");
      this.htmlHelper.addCssClass(tab, "selected");
      this.htmlHelper.addCssClass(tab, "selection_fix");
      this.htmlHelper.addCssClass(tabContent, "visible");
    }
  }

  private enterTab(tab: Element) {
    if (!this.htmlHelper.hasCssClass(tab, "selection_fix")) {
      this.htmlHelper.removeCssClass(tab, "documentationcenter_menuItem_unselected");
      this.htmlHelper.addCssClass(tab, "documentationcenter_menuItem_selected");
      this.htmlHelper.addCssClass(tab, "selected");
    }
  }

  private exitTab(tab: Element) {
    if (!this.htmlHelper.hasCssClass(tab, "selection_fix")) {
      this.htmlHelper.removeCssClass(tab, "documentationcenter_menuItem_selected");
      this.htmlHelper.removeCssClass(tab, "selected");
      this.htmlHelper.addCssClass(tab, "documentationcenter_menuItem_unselected");
    }
  }
}